var module = 'main', name = 'main/assets/svg/phone-icon.svg', content = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 20\"><path fill=\"#ffffff\" fill-rule=\"evenodd\" d=\"M 11.36 14.43 L 1.61 14.43 L 1.61 2.06 L 11.36 2.06 L 11.36 14.43 Z M 6.5 18.94 C 5.6 18.94 4.88 18.19 4.88 17.27 C 4.88 16.35 5.6 15.6 6.5 15.6 C 7.4 15.6 8.13 16.35 8.13 17.27 C 8.13 18.19 7.4 18.94 6.5 18.94 L 6.5 18.94 Z M 12.11 0 L 0.89 0 C 0.4 0 0 0.41 0 0.91 L 0 19.09 C 0 19.59 0.4 20 0.89 20 L 12.11 20 C 12.6 20 13 19.59 13 19.09 L 13 0.91 C 13 0.41 12.6 0 12.11 0 L 12.11 0 Z M 12.11 0\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/phone-icon.svg
// module id = 1308
// module chunks = 0